import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  API_URL,
  FILE_STORAGE,
  FILE_STORAGE_API
} from '../../../../constants'

// Utils
import { renderFullDate } from '../../../../utils/time'
import { translation } from '../../../../utils/helpers'

// Actions
import { getMessage } from '../../../../actions/mypage'

// Components
import Gallery from '../../../../shared/components/Gallery'
import { hasSubscriptionPermission } from '../../../../utils/auth'

// Elements
import Panel from '../../../../shared/elements/panel'
import Divider from '../../../../shared/elements/divider'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Grid from '../../../../shared/elements/grid'

class MyMessagesMessage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      message: {}
    }
  }

  componentDidMount () {
    if (typeof this.props.item !== 'undefined') {
      this.setState({
        message: this.props.item
      })
    } else {
      this.getMessage(this.props)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (typeof this.props.item !== 'undefined') {
      if (nextProps.item.Id !== this.props.item.Id) {
        this.setState({
          message: nextProps.item
        })
      }
    } else {
      if (nextProps.params.msgID !== this.props.params.msgID) {
        this.getMessage(nextProps)
      }
    }
  }

  getMessage (props) {
    this.setState({
      message: {}
    })
    this.props.getMessage(props.params.msgID).then((res) => {
      this.setState({
        message: res.data
      })
      this.props.getMessages()
    }, () => {
      window.toastr.error(translation('1908'), translation('216'))
    })
  }

  renderAttachments (files) {
    if (files.length === 0) return null
    // // Image files
    // let imgFiles = [...files]
    // imgFiles = imgFiles.filter((val, index) => {
    //   return val.IsImage
    // })
    // // Other files
    // let otherFiles = [...files]
    // otherFiles = otherFiles.filter((val, index) => {
    //   return !val.IsImage
    // })
    let imgFiles = []
    let otherFiles = []
    files.forEach(file => {
      file.IsImage ? imgFiles.push(file) : otherFiles.push(file)
    })

    const renderImage = (image, key) => {
      let url = FILE_STORAGE + image.ThumbURL
      let fullUrl = FILE_STORAGE + image.FileURL
      return (
        <div key={key}>
          <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
        </div>
      )
    }
    const renderFile = (file, key) => {
      // if (file.FileURL === null) return null
      const newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      const thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileNameWithFolders
      return (
        <li key={key} className='file-document'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <a className='file' target='_BLANK' href={newFileUrl}>
            {file.FileName}
          </a>
        </li>
      )
    }
    return (
      <LabelWrapper labelText={translation('352')}>
        {otherFiles.length !== 0 && (
          <div className='docs'>
            <ul>
              {otherFiles.map(renderFile)}
            </ul>
          </div>
        )}
        {imgFiles.length !== 0 && <Gallery files={imgFiles} renderImage={renderImage} />}
      </LabelWrapper>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    let { message } = this.state
    if (Object.keys(message).length === 0) return null
    // console.log(message)
    const makeTime = () => {
      return renderFullDate(message.CreationDate, true, true)
    }
    let labelText = (
      <Grid cols={[1, 'max-content']}>
        {message.SenderName}
        <span>{makeTime()}</span>
      </Grid>
    )
    return (
      <div className='myMessagesMessage__screen'>
        <Panel>
          <LabelWrapper labelText={labelText}>
            {message.Title}
          </LabelWrapper>
          <Divider />
          {message.Body.split('\n').map((line, key) => {
            return (
              <div className='description' key={key}>
                {line}<br />
              </div>
            )
          })}
          {this.renderAttachments(message.MessageFiles)}
        </Panel>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getMessage
})(MyMessagesMessage)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyMessages/Message/index.js